export default __webpack_public_path__ + "static/media/activity.92899ff5.png";